import { useEffect, useState } from 'react';

type Props = {
  id?: string;
  /** valor em reais (decimal). Ex.: 1234.56 */
  valor: number;
  onChange: (valor: number) => void;
  className?: string;
  ariaLabel?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
};

const formatador = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function formatarCentavos(centavos: number): string {
  return formatador.format(centavos / 100);
}

/**
 * Input monetário em padrão "centavos": digitação preenche da direita para a esquerda.
 * Ex.: usuário digita "1" → 0,01; digita "12345" → 123,45.
 * Valor externo é decimal em reais.
 */
export function InputMonetario({
  id,
  valor,
  onChange,
  className = 'input',
  ariaLabel,
  required,
  disabled,
  placeholder,
}: Props) {
  const [texto, setTexto] = useState(() => formatarCentavos(Math.round(valor * 100)));

  useEffect(() => {
    const cents = Math.round(valor * 100);
    const atualEmCents = Math.round(parseFloat(texto.replace(/\./g, '').replace(',', '.')) * 100);
    if (cents !== atualEmCents) {
      setTexto(formatarCentavos(cents));
    }
  }, [valor]);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const apenasDigitos = e.target.value.replace(/\D/g, '');
    const cents = apenasDigitos === '' ? 0 : parseInt(apenasDigitos, 10);
    setTexto(formatarCentavos(cents));
    onChange(cents / 100);
  }

  return (
    <input
      id={id}
      className={className}
      type="text"
      inputMode="numeric"
      value={texto}
      onChange={handleChange}
      aria-label={ariaLabel}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}
